import { gql } from '@apollo/client';
import {
  ArticleSummary,
  QueryArticleSummaryIfExistsArgs,
} from '../../../__generated__/queries-web';

export const GET_ARTICLE_SUMMARY = gql`
  query GetArticleSummary($where: ArticleSummaryUniqueFilterInput!) {
    articleSummaryIfExists(where: $where) {
      id
      body
      status
      updatedAt
    }
  }
`;

export interface GetArticleSummaryQuery {
  articleSummaryIfExists: Pick<
    ArticleSummary,
    'id' | 'body' | 'status' | 'updatedAt'
  > | null;
}

export type GetArticleSummaryQueryVariables = QueryArticleSummaryIfExistsArgs;
